// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowRightLightSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="currentColor">
            <polygon
                points="754 1380.8 753.125 1380 750.5 1382.4 747.875 1380 747 1380.8 750.5 1384"
                transform="matrix(0 1 1 0 -1379.5 -746.5)"
            />
        </svg>
    );
};

export default React.memo(IconArrowRightLightSmall);
